import type { NostrEvent } from '@nostrify/nostrify';

/**
 * Hardcoded npub blocklist.
 * Events from these pubkeys are filtered out of the feed.
 * Add hex pubkeys here (not npub — decode first if needed).
 */
const BLOCKED_PUBKEYS: string[] = [
  '431fa2f340f0adf8963d6d7c6e2c20d913278c691fe609fd3857db13d8f39feb', // npub1gv069u6q7zkl393ad47xutpqmyfj0rrfrlnqnlfc2ld38k8nnl4st9wa6q
];

/**
 * Hardcoded word filter list (case-insensitive).
 * Events whose content OR any `t` tag matches one of these words
 * are filtered out of the feed.
 */
const BLOCKED_WORDS: string[] = [
  'bitcoin',
];

const blockedPubkeySet = new Set(BLOCKED_PUBKEYS);

/** Compiled regex from BLOCKED_WORDS — matches any word as a case-insensitive pattern. */
const blockedWordsRegex: RegExp | null =
  BLOCKED_WORDS.length > 0
    ? new RegExp(BLOCKED_WORDS.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'i')
    : null;

/**
 * Returns true if the event should be hidden from the feed.
 */
export function isBlocked(event: NostrEvent): boolean {
  // Check pubkey blocklist
  if (blockedPubkeySet.has(event.pubkey)) return true;

  // Check word filter against content
  if (blockedWordsRegex) {
    if (blockedWordsRegex.test(event.content)) return true;

    // Check t tags (hashtags)
    for (const tag of event.tags) {
      if (tag[0] === 't' && tag[1] && blockedWordsRegex.test(tag[1])) return true;
    }

    // Check title tag
    const title = event.tags.find(([name]) => name === 'title')?.[1];
    if (title && blockedWordsRegex.test(title)) return true;
  }

  return false;
}
